import { useTranslation } from 'react-i18next';
import Button from '@pelckmans/elementis/components/button';
import EmptyState from '../../../../../shared-components/EmptyState';
import AddLicenseModal from '../../../../../shared-components/AddLicenseModal';
import { useContext } from 'react';
import ModalContext from '../../../../../contexts/ModalContext';
import ModuleContext from '../../../../material/_contexts/ModuleContext';

const BASE = 'PAGES.ASSIGNMENTS.TEACHER.EMPTY_STATE.NO_LICENSE';

function NoLicenseState() {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const { refetch } = useContext(ModuleContext);

  const showAddLicenseModal = () => showModal(<AddLicenseModal id="add-license-modal" onRefetch={refetch} />);

  return (
    <EmptyState
      variant="table"
      headerTitle={t(`${BASE}.TITLE`)}
      bodyText={t(`${BASE}.TEXT`)}
      cta={
        <Button prominence="secondary" size="md" as="button" onClick={showAddLicenseModal}>
          {t(`${BASE}.CTA`)}
        </Button>
      }
    />
  );
}

export default NoLicenseState;
